import { getTabs } from '../../data';
import { NavGrid } from '../NavGrid/NavGrid';
import { TabNavigationItem } from '../TabNavigationItem/TabNavigationItem';

const [_traders, usersAndCompanies, _contracts, deals, finance, _transport, inspections, _advanced, support] =
  getTabs();

const POPULAR_LINKS = [
  usersAndCompanies.links[0],
  usersAndCompanies.links[3],
  deals.links[1],
  finance.links[7],
  inspections.links[0],
  support.links[0],
];

export const PopularLinks = () => {
  return (
    <NavGrid>
      {POPULAR_LINKS?.map(({ label, icon, href, description, isLegacy }, index) =>
        isLegacy === false ? (
          <TabNavigationItem key={index} label={label} icon={icon} to={href} description={description} />
        ) : (
          <TabNavigationItem key={index} label={label} icon={icon} href={href} description={description} />
        )
      )}
    </NavGrid>
  );
};
